import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { FullPageLoader } from '../../components';

export const Logout = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  }, [logout]);

  return <FullPageLoader />;
};
